import { render } from "./StockAdjustments.vue?vue&type=template&id=29239457&scoped=true"
import script from "./StockAdjustments.vue?vue&type=script&lang=js"
export * from "./StockAdjustments.vue?vue&type=script&lang=js"

import "./StockAdjustments.vue?vue&type=style&index=0&id=29239457&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29239457"]])

export default __exports__